import { ArrowUpDown } from "lucide-react";
import { useFacetedParams } from "@/hooks/useFacetedParams";

export interface SortOption {
  value: string;
  label: string;
}

interface ListSortSelectProps {
  options: SortOption[];
  /** Hodnota použitá, když v URL nic není. */
  defaultValue: string;
}

/**
 * Třídění seznamu. Stejně jako filtry a hledání žije v URL (`?sort=`), takže si
 * kolega může poslat odkaz na „moje destinace seřazené podle názvu" a otevře se
 * mu totéž. Stránkování se při změně řazení vrací na první stránku.
 */
export default function ListSortSelect({ options, defaultValue }: ListSortSelectProps) {
  const { params, setParam } = useFacetedParams();
  const value = params.get("sort") ?? defaultValue;

  return (
    <div className="relative">
      <ArrowUpDown className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
      <select
        value={value}
        onChange={(e) => setParam("sort", e.target.value === defaultValue ? null : e.target.value)}
        className="input w-full pl-9 sm:w-56"
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}
